// extracted by mini-css-extract-plugin
module.exports = {"user_desc":"userData_user_desc__3vtgB","description":"userData_description__155DB","user":"userData_user__1ieyr","user__info":"userData_user__info__1haWI"};